export default __webpack_public_path__ + "static/media/javascript-plain.188a245c.svg";